import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    backgroundColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  questionTitle: {
    marginBottom: "2vh",
  },
  icon: {
    marginHorizontal: "2vw",
    fontSize: "8vw",
  },
});
